import React, { useEffect } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
// import './ProfileLayout.scss';
import { accessTokenApi, listSections } from "../../services/CallApi";
import {
  ErrorUI,
  OpenStudioSelectModal,
} from "../../components/UI/Modals/Modals";
import {
  CompleteProfile,
  ProtectedOndemand,
  ProtectedProfile,
} from "../../services/ProtectedRoute";
import InternalLayout from "../InternalLayout/InternalLayout";
import { useState } from "react";
import { CheckValue } from "../../services/CommonFunction";
import SignUpStepsWrapperContainer from "../../components/ReusableComponents/SignUpStepsWrapper/SignUpStepsWrapper";
import { useSelector, useDispatch } from "react-redux";
import { profileActions } from "../../store";
import WaitingRoom from "../../containers/NewCasting/WaitingRoomScreen/WaitingRoom";
import OngoingRoom from "../../containers/NewCasting/Ongoing/OngoingRoom";

const ProfileLayout = ({ ...props }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { email, defaultGym } = useSelector(
    (state) => state.profile.profileData
  );
  useEffect(() => {
    if (defaultGym) {
      getSections(defaultGym.gym_id);
    }
  }, [defaultGym]);

  const getSections = (gym_id) => {
    listSections(gym_id).then((res) => {
      if (res.status) {
        dispatch(
          profileActions.updateSections({
            sections: res.list.section_list,
            categories: res.list.featured_categories,
          })
        );
      } else {
        ErrorUI(res.list, () => getSections(gym_id));
      }
    });
  };

  useEffect(() => {
    //console.log('enter-profilelayout', email);
    // localStorage.removeItem("workoutData");
    // localStorage.removeItem("ondemandData");
    // localStorage.removeItem("setVolume");
    if (CheckValue(email)) {
    } else {
      getAccessTokenLoginData();
    }
  }, []);

  const getAccessTokenLoginData = () => {
    accessTokenApi().then(async (res) => {
      try {
        console.log(res);
        if (res.status) {
          dispatch(profileActions.updateProfileData(res.data));
          if (!CheckValue(res.data.defaultGym)) {
            OpenStudioSelectModal();
          }
        } else {
          ErrorUI(res.data, () => getAccessTokenLoginData());
        }
      } catch (error) {
        console.log(error);
      }
    });
  };
  return (
    <React.Fragment>
      {CheckValue(email) ? (
        <Switch>
          <CompleteProfile
            path="/SignUpSteps"
            exact
            component={SignUpStepsWrapperContainer}
          />
          <ProtectedOndemand
            exact
            path="/waitingRoom"
            component={WaitingRoom}
          />
          <ProtectedOndemand
            exact
            path="/ongoingRoom"
            component={OngoingRoom}
          />
          <ProtectedOndemand
            exact
            path="/hangoutRoom"
            component={WaitingRoom}
          />
          <ProtectedProfile path="/" component={InternalLayout} />
        </Switch>
      ) : null}
    </React.Fragment>
  );
};

export default ProfileLayout;
